import axios from 'axios'
import { apiUrl } from 'Services/accessUrl'
import { getUnique } from 'Services/axiosService'

const endpoint = `${apiUrl.stable}/localizacao`

export const getStateByPrefix = (statePrefix) => {
  const url = `${endpoint}/estado/prefixo`

  const params = {
    prefix: statePrefix
  }

  return getUnique(url, { params }, 'statePrefix')
}

export const getStateList = () => {
  const url = `${endpoint}/estado`

  return axios.get(url)
}

/**
 * @param {string} cityPrefix
 * @returns {Promise.<{ data: ApiRegionCity[] }>}
 */
export const getCityByPrefix = (cityPrefix) => {
  const url = `${endpoint}/cidade/prefixo`
  const params = { prefix: cityPrefix }

  return getUnique(url, { params }, 'cityPrefix')
}

export const getCitiesByStateId = (idState) => {
  const url = `${endpoint}/cidade/idestado`

  const params = {
    idestado: idState
  }

  return axios.get(url, { params })
}

export const getCep = (cepLocation) => {
  const url = `${endpoint}/endereco/cep`

  const params = {
    cep: cepLocation
  }

  return axios.get(url, { params })
}

export const getBroughByPrefix = (neightborhoodPrefix) => {
  const url = `${endpoint}/bairro/prefixo`

  const params = {
    prefix: neightborhoodPrefix
  }

  return getUnique(url, { params }, 'broughPrefix')
}

export const getZoneByPrefix = (zonePrefix) => {
  const url = `${endpoint}/zona/prefixo`

  const params = {
    prefix: zonePrefix
  }

  return getUnique(url, { params }, 'zonePrefix')
}

export const getCityBySlug = (state, city, cache = 'citySlug') => {
  const url = `${endpoint}/cidade/uf/cityslug`

  const params = {
    uf: state,
    cityslug: city,
  }

  return getUnique(url, { params }, cache)
}

export default {
  getBroughByPrefix,
  getCep,
  getCitiesByStateId,
  getCityByPrefix,
  getStateByPrefix,
  getStateList,
  getZoneByPrefix,
  getCityBySlug,
}